import {FullPageSpinner} from 'components/Page'
import {useAuth} from 'contexts/authContext'
import * as React from 'react'

const AuthenticatedApp = React.lazy(() =>
  import(/* webpackPrefetch: true */ './AuthenticatedApp'),
)
const UnauthenticatedApp = React.lazy(() => import('./UnAuthenticatedApp'))

export default function App() {
  const { user } = useAuth()

  return (
    <React.Suspense fallback={<FullPageSpinner />}>
      {user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
    </React.Suspense>
  )
}
